import { useCallback, useEffect, useMemo, useRef } from 'react'
import debounce from 'lodash-es/debounce'

export function useDebounceFunc(callback, debounceTime = 500) {
  const callbackRef = useRef(null)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  const debouncedCallback = useMemo(
    () =>
      debounce(
        // callback is invoked from the debounce timer, never during render.
        // Reading callbackRef inside keeps the latest callback without
        // re-creating the debounce timer on every callback identity change.
        // eslint-disable-next-line react-hooks/refs
        (...args) => callbackRef.current?.(...args),
        debounceTime
      ),
    [debounceTime]
  )

  useEffect(
    () => () => {
      debouncedCallback.cancel()
    },
    [debouncedCallback]
  )

  const cancelDebounce = useCallback(() => {
    debouncedCallback.cancel()
  }, [debouncedCallback])

  return {
    cancelDebounce,
    debouncedHandler: debouncedCallback,
  }
}
